<div ngClass="p-t-l p-r-l">
	<button mat-icon-button class="close-button" (click)="onCloseClick()">
		<img
			src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/crossBlack/public"
		/>
	</button>
</div>
<div ngClass="m-l-l" fxLayout="row" fxLayoutAlign="space-between start">
	<h2 i18n="@@editFundraiserLocation_title">Edit Fundraiser Location</h2>
	<mat-icon *ngIf="isLoading">
		<mat-spinner color="accent" diameter="16"></mat-spinner>
	</mat-icon>
</div>
<mat-dialog-content>
	<form [formGroup]="locationForm">
		<!--LOCATION-->
		<mat-form-field class="w-100" appearance="outline">
			<mat-label i18n="@@editFundraiserLocation_locationName_title">
				Location name
			</mat-label>
			<input
				placeholder="{{ locationInputPlaceholder }}"
				#locationRef
				matInput
				id="fundraiserLocationInput"
				formControlName="locationControl"
				[matAutocomplete]="locationAuto"
			/>
			<!-- <img matSuffix src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/arrowDropDown/public"/> -->
			<mat-autocomplete #locationAuto="matAutocomplete" (closed)="setPlaceId()">
				<mat-option
					*ngFor="let location of locations"
					[value]="location.description"
				>
					{{ location.description }}
				</mat-option>
			</mat-autocomplete>
			<mat-error
				*ngIf="
					locationForm.controls['locationControl'].errors &&
					locationForm.controls['locationControl'].errors['location']
				"
				>Invalid Location</mat-error
			>
		</mat-form-field>
	</form>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button
		[disabled]="!locationForm.dirty || locationForm.invalid || isSave"
		mat-flat-button
		color="accent"
		id="fundraiserLocationSaveButton"
		(click)="dialogClose()"
	>
		<span i18n="@@button_save">Save</span>
		<mat-icon *ngIf="isSave" ngClass="m-l-xs">
			<mat-spinner
				color="accent"
				diameter="16"
				i18n="@@editFundraiserLocation_spinner"
			>
			</mat-spinner>
		</mat-icon>
	</button>
</mat-dialog-actions>
